/**
 * MTA header helpers (Dwell 4.2 / Horizon).
 *
 * Mobile drawer extras: Dwell's header drawer (snippets/header-drawer.liquid)
 * has no slot for secondary/utility links or an account link. The
 * `_header-menu` block renders them into a <template data-mta-drawer-extras>
 * next to the drawer; this script moves that content into the drawer's
 * `.menu-drawer__utility-links` container so it appears at the bottom of the
 * menu. Runs on load and again whenever the header is re-rendered (theme
 * editor / Section Rendering API) via a MutationObserver.
 */
(function () {
  const MOVED_ATTR = 'data-mta-extras-mounted';

  function mountDrawerExtras() {
    const template = document.querySelector('template[data-mta-drawer-extras]');
    if (!(template instanceof HTMLTemplateElement)) return;

    const drawer = document.querySelector('header-drawer[data-header-drawer-type="mobile-drawer"], header-drawer');
    if (!drawer) return;

    const target = drawer.querySelector('.menu-drawer__utility-links');
    if (!target || target.hasAttribute(MOVED_ATTR)) return;

    const content = template.content.cloneNode(true);
    target.prepend(content);
    target.setAttribute(MOVED_ATTR, '');
  }

  function init() {
    mountDrawerExtras();

    const header = document.getElementById('header-component');
    if (!header || !('MutationObserver' in window)) return;

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        mountDrawerExtras();
      });
    });
    observer.observe(header, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Theme editor re-renders the section; re-mount after it settles.
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(mountDrawerExtras));
})();
